module.exports = __webpack_public_path__ + "static/img/content-4.6f4cca3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cebc/content-4.jpeg
// module id = mkeO
// module chunks = 0